import { render, staticRenderFns } from "./tagsEditor.vue?vue&type=template&id=4faeef80&scoped=true"
import script from "./tagsEditor.vue?vue&type=script&lang=js"
export * from "./tagsEditor.vue?vue&type=script&lang=js"
import style0 from "./tagsEditor.vue?vue&type=style&index=0&id=4faeef80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faeef80",
  null
  
)

export default component.exports